<template>
  <div ref="charts" style="width:100%;height:240px"></div>
</template>

<script>
  import echarts from "echarts";
  import { onMounted, ref } from "vue";
  export default {
    name: 'echartCake',
    props: {
      echartsData: {
        type: Object
      },
    },
    setup(props) {
      const charts = ref();
      onMounted(() => {
        const chart = charts.value;
        if (chart) {
          var myChart = echarts.init(chart);
          const option = {
            tooltip: {
              trigger: 'item',
              formatter: '{b}<br/>占比：{d}%<br/>数值：{c}'
            },
            legend: {
              textStyle: {
                color: '#000',
                fontSize: 14
              },
              data: []
            },
            series: {
              type: 'pie',
              radius: '70%',           //饼图中饼状部分的大小所占整个父元素的百分比
              center: ['center', '50%'],  //整个饼图在整个父元素中的位置
              data: props.echartsData.chartList,
              itemStyle: {
                normal: {
                  label: {
                    show: false,
                  },
                  labelLine: {
                    show: false
                  }
                }
              },
            }
          };
          myChart.setOption(option);
          window.addEventListener("resize", function () {
            myChart.resize();
          });
        }
        window.removeEventListener("resize", function () {
          myChart.resize();
        });
      });
      return {
        charts,
      };
    },
  };
</script>